export default __webpack_public_path__ + "static/media/Zoo_09.ac8e75ed.png";